<template>
    <div class="mypartie">
      
        <div class="spartie" v-if="partie">
            <div class="g_desktopOn"> {{titlePartie}} :
                <span v-if="partie.state=='INPROGRESS'">en cours </span>
                <span v-if="partie.state=='FINISH'">terminé  </span>
                <span v-if="partie.state=='WAITING'">en attente</span>
            </div>
            <div class="waiting " v-if="partie.state=='WAITING'">
                Veuillez attendre que l'organisateur démarre la partie...
            </div>
             
        </div>
        
        <div v-if="nav=='score'">
        <div class="team">
            <my-equipe
                    :type="myKey"
                    :equipe="equipe"
                    :indexPartie = "indexPartie"
                    :joueurs = "tournoi.joueurs"
                    :partie="partie"
                    @selectJoueur="selectJoueur"
                     :disabledScore="scoreSaved"
                    theme="is-success"
                     :mode="tournoi.options.mode"
                     @openModalScore="openModalScore"
                />
            <div class="buttonMene">
            <s-button v-if="tournoi" width="100px" theme="is-primary is-medium" icon="plus" 
            :disabled="disabledMene"
            label="Mène" @onclick="addMene(myKey)"/>
            </div>
            </div>
            <div class="vs">
                        <br/><br/>
                    </div>
            <div  class="teamVS">
               
            <my-equipe
                :type="myKey=='contre' ? 'joueurs' : 'contre'"
                :equipe="equipe"
                :indexPartie = "indexPartie"
                :joueurs = "tournoi.joueurs"
                :partie="partie"
                @selectJoueur="selectJoueur"
                :disabledScore="scoreSaved"
                 :mode="tournoi.options.mode"
                theme="is-danger"
                @openModalScore="openModalScore"
            />
            <div class="buttonMene">
            <s-button v-if="tournoi" width="100px" theme="is-primary is-medium" 
            :disabled="disabledMene"
            icon="plus" label="Mène" @onclick="addMene(myKey=='contre' ? 'joueurs' : 'contre')"/>
            </div>
        </div>
            <div >
                <div class="histoMene" v-if="equipe">
                    <s-button label="Les mènes" 
                    icon="history" 
                     :disabled="disabledMene"
                    :theme="loadingHisto ? 'is-loading is-normal' : 'is-warning is-normal'" 
                    @onclick="openHistoriqueMenes()"/>
                </div>
                <div style="padding-top: 20px;text-align: right;padding-right: 10px" v-if="equipe && partie">
                    <span v-if="equipe.score">
                    <s-button theme="is-success" icon="save" label="Enregistrer" @onclick="saveScore(equipe)"
                        :disabled="partie.state!='INPROGRESS' || equipe.state=='FINISH'"
                        v-if="joueur.id!=equipe.score.idJoueur"
                    />
                
                    <s-button theme="is-warning" icon="save" label="Annuler" @onclick="supprimerScore(equipe)"
                        :disabled="partie.state!='INPROGRESS' || equipe.state=='FINISH'"
                        v-if="equipe.score.validate && joueur.id==equipe.score.idJoueur"
                    />
                    </span>
                </div>
            </div>
        </div>
        
         <div v-if="nav=='addmene'">
                <div class="pointButtons" v-if="equipe && equipeVS">
                 
                  <div :class="myKey==this.vs ? 'equipe_joueur' : 'equipe_contre'">
                     <h1 > {{equipeLabel()}} </h1>
                      a remorté la mène de<br/>
                      <h1> {{pointAddMene}} points</h1>
                  </div>
                    
                <br/>
                <span class="explain_addmene">
                    <s-l id="myTournoi_explain_addMene">Cliquez sur le nombre de boules gagnantes :</s-l>
                </span>
                <div>
                <div v-for="point in 6" class="point"  >
                    <s-button label="" 
                        :theme="themePoint(point, pointAddMene)" 
                        icon="baseball-ball" 
                        @onclick="addPoint(point)"/>
                </div>
                </div> <br/>
                <div style="width:80%;margin-left:auto;margin-right:auto;">
                    <div style="float:left">
                        <s-button icon="ban"
                            @onclick="nav='score'"
                            label='Annuler'
                            theme="is-warning"/>
                    </div>
                    <div style="float:right">
                        <s-button icon="save"
                            @onclick="saveMene"
                            label='Enregistrer'
                            theme="is-success"/>
                    </div>
                </div>
                </div>
        </div>
        <div v-if="nav=='histoMenes'" class="historiqueWindow" >
            <div class="titleHisto">
                <div style="float:left">
                    <s-button icon="undo" @onclick="nav='score'" label="" theme="is-warning"/>
                </div>
                Historique des mènes
            </div>
            <div class="listMenes">
                <div v-for="historiqueMeneItem in historiqueMenes" class="histoItem">
                    <div class="histoHeader">{{formatDate(historiqueMeneItem.date)}} 
                        <div style="float:right">
                            <s-button theme="is-danger is-small" icon="trash" label="" 
                            @onclick="setOpenModalDeleteMene(historiqueMeneItem)"/>
                        </div>
                        </div>                      
                    <div class="equipe_joueur">{{equipeLabel("joueurs")}} : <div style="float:right">{{historiqueMeneItem.joueur}}</div> </div>
                    <div class="equipe_contre">{{equipeLabel("contre")}} : <div style="float:right">{{historiqueMeneItem.contre}}</div> </div>
                </div>
                <div style="margin: 10px" v-show="historiqueMenes.length==0">
                        <b>Aucune mène.</b>
                </div>
            </div>
            
            <s-confirm 
                title="Supprimer une mène"
                :open = "openModalDeleteMene"
                @yes="deleteMene(meneItem)"
                @no="openModalDeleteMene=false"
            >
                Confirmez vous la suppression ?
            </s-confirm>
        </div>
        <div style="margin-top:20px" v-if="tournoi.options.competition==3" >
        <s-button label="Ma poule"
                  @onclick="modalPoule=true"
                  icon="border-all"
                  theme="is-info"/>
        </div>
       <poule 
            :tournoi="tournoi"
            :open="modalPoule"
            :numPoule="numPoule"
            @close="modalPoule=false"
            v-if="numPoule!=null"
        />
        <s-modal
            :open="modalScore"
            :close="false"
            @close="modalScore=false"
            @cancel="modalScore=false"
            :cancel="true"
        >
            <div v-if="equipe!=null && typeSelected!=null ">
            L'equipe 
                <span :class="'titleScore'+typeSelected" v-if="equipe[typeSelected].J1!=null"> {{equipe[typeSelected].J1.numero+1}} </span>
                <span :class="'titleScore'+typeSelected" v-if="equipe[typeSelected].J2!=null"> {{equipe[typeSelected].J2.numero+1}} </span>
                <span :class="'titleScore'+typeSelected" v-if="equipe[typeSelected].J3!=null"> {{equipe[typeSelected].J3.numero+1}} </span>
            a perdu et a marqué :
            </div>
            <div v-for="score in tabScore" class="score">
                <s-button v-if="equipe!=null" :label="score" :icon="equipe.score[typeSelected]==score ? 'check' : ''"
                    :theme="(typeSelected=='joueurs' ? 'is-info ' : 'is-danger ') + 'is-large'" @onclick="saveScorePoint(score)"/>
            </div>
            <div style="float:right;margin-top: 50px;">
            <s-button icon="eraser" label="Supprimer les scores" theme="is-dark" @onclick="supprimerScore"/>
            </div>
        </s-modal>
    </div>
</template>
<style scoped>
    .titleScorejoueurs {
        border: thin solid blue;
        color: blue;
        display: inline-block;
        border-radius: 20px;
        margin: 10px;
        padding: 3px;
        font-weight: bolder;
        width: 30px;
        text-align: center;
    }
    .titleScorecontre {
        border: thin solid red;
        color: red;
        display: inline-block;
        border-radius: 20px;
        margin: 10px;
        padding: 3px;
        font-weight: bolder;
        width: 30px;
        text-align: center;
    }
    .score {
        display: inline-block;
        margin: 10px;
    }
    .stateJeu {
        font-weight: bolder;
        font-size: 18px;
        color: black;
    }
    .historiqueWindow {
        
        height: 420px;
        position: fixed;
        top: 40px;
        width: 100%;
        background-color: white;
        padding: 5px;
        z-index: 2;
    }
 .histoMene {
        float: left;
        padding-top: 20px;
        padding-left: 10px;
    }
     @media screen and (min-width: 420px) {  
        
         .pointButtons {
            width: 100%;
            text-align: center;
            font-size: 25px;
            color: black;
            margin-top: 30px;
        }
     }
    @media screen and (max-width: 420px) {  
         .pointButtons {
            width: 100%;
            text-align: center;
            font-size: 25px;
            color: black;
            margin-top: 20px;
            background-color: white;
            box-shadow: 2px 2px 2px 2px black;
            height: 350px;
        }
        .mypartie {
            
            width: 100%;
            padding-top: 70px;
           
        }
    }
    .titleHisto {
        font-weight: bolder;
        font-size: 20px;
        color: black;
        padding-top: 20px;
        margin-bottom: 20px;
    }
    .histoItem {
        margin-bottom: 10px;
        margin-left: 0px;
        margin-right: 10px;
        
    }
    .histoHeader {
        background-color: #ffffff;
        color: black;
        font-size: 20px;
        font-weight: bolder;
        height: 40px;
        padding-top: 5px;
        padding-right: 5px;
        padding-left: 5px;
    }
    .listMenes {
        overflow-y: auto;
        height: 330px;
        box-shadow: 2px 2px 2px 2px gray;
    }
   
   
    .explain_addmene {
        font-size: 18px;
        font-weight: bolder;
    }
    .point {
        display: inline-block;
        margin-left: 1px;
    }
    .waiting {
        font-size: 14px;
    }
     .spartie {
         font-size: 23px;
         color: black;
         font-weight: bolder;
     }
     .team {
        display: inline-block;
        height: 220px;
        background-color: #68CC77;
        margin-top: 5px;
        border-radius: 10px;
        width: 48%;
    }
    .teamVS {
        display: inline-block;
        background-color: rgb(209, 63, 63);
        margin-top: 10px;
        height: 220px;
        border-radius: 10px;
         width: 48%;
    }
    .vs {
         display: inline-block;
         width: 8px;
         text-align: center;

    }

    .equipe_contre {
        background-color: rgb(209, 63, 63);
        color: white;
        padding: 3px;
        font-size: 14px;
    }
     .equipe_joueur {
        background-color: #68CC77;
        color: white;
        padding: 3px;
        font-size: 14px;
    }
    .buttonMene {
        padding-top: 10px;
    }
</style>
<script>
import myEquipe from '@/views/tournoi/inProgress/equipe';
import firebase_api    from '@/firebase/firebase_api';
import poule from '@/views/myTournoi/poule.vue';
import Championnat_DB from "@/firebase/championnat";
import tournoi_fct from '@/firebase/tournoi';
export default {
    props: ["joueur", "club", "tournoi","numeroJoueur", "indexPartie"],
    components: {
        myEquipe,
        poule
    },
    data() {
         return {
            equipe: null,
            partie: null,
            modalPoule: false,
            myKey: null,
            addModalMene: false,
            equipeVS: null,
            vs: null,
            pointAddMene: 0,
            nav: 'score',
            historiqueMenes:[],
            openModalDeleteMene: false,
            meneItem: null,
            loadingHisto: false,
            numPoule: null,
            modalScore: false,
            typeSelected: null
         }
     },
     computed: {
         indexPartieComputed: {
             get() {
                return this.indexPartie;
             }
         },
         
         tabScore: {
            get() {
                var tab=[];
                for (var i=0;i<this.pointMax;i++)
                    tab.push(i+'');
                return tab;
            }
        },
        pointMax: {
            get() {
                if (this.partie!=null)
                    if (typeof(this.partie.maxPoint)=="undefined")
                        return 13;
                    else
                        return this.partie.maxPoint
                else
                    return 13;
            },
            set(val) {
                this.partie.maxPoint = parseInt(val);
            }
        },
         titlePartie: {
             get() {
                 if (this.tournoi.options.competition == 3) {
                    if (this.indexPartie==0)
                        return "Poule - Partie " + (this.indexPartie+1)
                    if (this.indexPartie==1)
                        return "Poule - Partie " + (this.indexPartie+1)
                    if (this.indexPartie==2)
                        return "Barrage"
                    if (this.indexPartie>2)
                        return "Eliminatoire " + (this.indexPartie+1)
                 }
                 else 
                    return "Partie " + (this.indexPartie+1)
             }
         },
         scoreSaved: {
             get() {
                 if (this.equipe!=null) {
                 if (this.equipe.length!=0) {
                    if (typeof(this.equipe.score.validate)=="undefined")
                        return false;
                    else 
                        return true;
                 }
                 else   
                    return false;
                 }
                 else
                    return false;
             }
         },
         disabledMene: {
             get() {
                 if (this.equipe!=null && this.partie!=null) {
                    var bool = this.partie.state!='INPROGRESS' || this.equipe.state == 'FINISH';
                   
                    if (!bool) {
                     
                        if (typeof(this.equipe.score) != "undefined") {
                            if (typeof(this.equipe.score.validate)=="undefined") {
                                bool = false;
                            }
                            else {
                                bool = this.equipe.score.validate;
                            }
                        }
                    }
                    return bool;
               }
             }
         }
     },
   
    methods: {
        supprimerScore() {
            this.modalScore = false;
            this.equipe.score['joueurs'] = '';
            this.equipe.score['contre'] = '';
            this.equipe.state = 'INPROGRESS';
            delete this.equipe.score.validate;
            this.saveScore(this.equipe);
        },
        openModalScore(equipe, type) {
            this.modalScore = true;
            this.typeSelected = type;
        },
        save() {
            this.saveScore(this.equipe);
        },
        saveScorePoint(score) {
                var typeVS = this.typeSelected == "contre" ? "joueurs" : "contre";
                this.equipe.score[this.typeSelected] = parseInt(score);
                if (!isNaN(score)) {
                    this.equipe.score[typeVS] = this.pointMax;
                } 
                this.saveScore(this.equipe);
                this.modalScore = false;
          },
        saveScore(equipe) {
             var idJoueur = this.joueur.id;
      
            if (typeof(this.equipe.score.validate) != "undefined") {
                if (this.equipe.score.validate) {
                    if (this.equipe.score.idJoueur != idJoueur)
                        this.equipe.state = "FINISH"
                    else {
                        delete this.equipe.score["validate"];
                        delete this.equipe.score["idJoueur"];
                    }
                    if (this.equipe.state == "FINISH" && this.tournoi.options.competition == 3) {
                        if (this.indexPartie>=0 && this.indexPartie<3) {
                            Championnat_DB.object.setScorePool(this.club, this.tournoi, this.indexPartie, this.equipe, ()=>{
                            });
                        }
                        if( this.indexPartie>2) {
                            Championnat_DB.object.setScore(this.club, this.tournoi, this.indexPartie, this.equipe, ()=>{
                                if (typeof(this.tournoi.cadrage)!="undefined")
                                    if (this.tournoi.cadrage)
                                        Championnat_DB.object.eliminatoire(this.club, this.tournoi, this.indexPartie).then(json=>{
                                    })
                            })
                        }    
                    }
                    else if (this.tournoi.options.GG) {
                        // il faut faire attention car si les gars renseigne leur score
                        // bah du coup le tirage va le prendre en compte alors que leur n'a pas forcément 
                        // été validé 
                        
                        tournoi_fct.object.setTournoiGG(this.club, this.tournoi, this.indexPartie, equipe)
                    }
                }
            }
            else {
                this.equipe.score.validate = true;
                this.equipe.score.idJoueur = idJoueur;
            }
     
            this.$firestoreRefs.equipe.set(this.equipe);

        },
         openHistoriqueMenes() {
            this.historiqueMenes = [];
            this.loadingHisto = true;
            this.$firestoreRefs.equipe.collection("mene").orderBy("date", 'desc').get().then(snapshot=>{
                snapshot.docs.forEach(doc=>{
                    var meneItemData = doc.data();
                    meneItemData.id = doc.id;
                    this.historiqueMenes.push(meneItemData);
                });
            })
            .then(()=>{
                this.loadingHisto = false;
                this.nav = "histoMenes";
            })
        },
         themePoint (point, pointAddMene) {
            if (point > pointAddMene)
                return 'is-light is-medium' 
            else {
                if (this.vs == 'joueur')
                    return 'is-success is-medium'
                else    
                    return 'is-success is-medium'
            }
            
        },
        formatDate(timestamp) {
            var dateCurrent = new Date(timestamp);
            var options = {weekday: "numeric", year: "numeric", month: "numeric", day: "numeric"};

            return dateCurrent.toLocaleDateString('fr-FR') + " à " + 
                dateCurrent.toLocaleTimeString([],{hour: '2-digit', minute:'2-digit'});
        },
         equipeLabel(vs) {
            if (typeof(vs)=="undefined") {
                var equipe  = this.equipeVS;
            }
            else {
                var equipe = this.equipe[vs];
            }
            var equipeLabel;
            if (typeof(equipe)!="undefined") {

            
            if (typeof(equipe.J1)!='undefined' && equipe.J1!=null) 
                equipeLabel = this.tournoi.joueurs[equipe.J1.numero].pseudo + ' ' + equipe.J1.numero ;
            if (typeof(equipe.J2)!='undefined' && equipe.J2!=null) 
                equipeLabel += " / " + this.tournoi.joueurs[equipe.J2.numero].pseudo + ' ' + equipe.J2.numero + '';
            if (typeof(equipe.J3)!='undefined' && equipe.J3!=null) 
                equipeLabel += " / " + this.tournoi.joueurs[equipe.J3.numero].pseudo + ' ' + equipe.J3.numero + '';
            }
            return equipeLabel;
        },
        setOpenModalDeleteMene(meneItem){
            this.meneItem = meneItem;
            this.openModalDeleteMene = true;
        },
        addMene(vs) {
            this.$firestoreRefs.equipe.update({
                state: 'WAITING'
            }).then(()=>{
                this.equipeVS = this.equipe[vs];
                this.vs = vs;
                this.nav = "addmene"
            })
        },
        saveMene() {
           
            if (this.equipe.score[this.vs]=='' || this.equipe.score[this.vs]==null || isNaN(this.equipe.score[this.vs]))
                var score = 0;
            else
                var score = parseInt(this.equipe.score[this.vs]);
            
            score += parseInt(this.pointAddMene);
            var maxPoint = 13;
            if (typeof(this.partie.maxPoint)!="undefined")
                maxPoint = this.partie.maxPoint;
            if (score > maxPoint)
                score = maxPoint;
            this.equipe.score[this.vs] = score;
            this.equipe.state = "INPROGRESS";
            this.$firestoreRefs.equipe.set(
                this.equipe
            ).then(()=>{
                var scoreMene= {
                    joueur : 0,
                    contre: 0,
                    date: (new Date()).getTime()
                }
                scoreMene[this.vs] = this.pointAddMene;
                
                this.$firestoreRefs.equipe.collection("mene").add(
                    scoreMene
                ).then(()=>{
                        this.vs = null;
                        this.pointAddMene = 0;
                        this.equipeVS = {};
                        this.nav = 'score'
                })
            })
        },
        closeAddTheme() {
            this.addModalMene=false;
            if (this.partieCurrent["P"+this.indexPartie.toString()].tournoi.state == "INPROGRESS") {
                this.$firestoreRefs.equipe.update({
                state: 'INPROGRESS'
                }).then(()=>{
                     this.vs = null;
                    this.pointAddMene = 0;
                    this.equipeVS = {};
                    this.addModalMene = false
                })
            }
        },
        addPoint(point) {
            this.pointAddMene = point;

        },
         deleteMene() {
            var vs;
            if (this.meneItem.joueur != 0)
                vs = "joueur";
            else    
                vs  = "contre";
            this.equipe.score[vs] = this.equipe.score[vs]  - this.meneItem[vs];
            if (this.equipe.score[vs]<0)
                this.equipe.score[vs] = 0;
            this.$firestoreRefs.equipe.set(
                this.equipe
            ).then (()=>{
                this.$firestoreRefs.equipe.collection("mene").doc(this.meneItem.id).delete().then(()=>{
                this.openModalDeleteMene = false;
                this.openHistoriqueMenes();
             });
            })
        },
        getPartie() {
            return this.partie;
        },
        initEquipe() {
            
             if (this.club!=null && this.tournoi!=null) {
              
                if (this.tournoi.state=="INPROGRESS") {
                this.$bind("partie",firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("tournois").doc(this.tournoi.id)
                        .collection("parties").doc("P"+this.indexPartie)).then(partie=>{
                            
                        })

                firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("tournois").doc(this.tournoi.id)
                        .collection("parties").doc("P"+this.indexPartie).collection("equipes")
                            .get().then(equipes=>{
                                
                                equipes.docs.forEach(docEquipe=>{
                                    var equipeData = docEquipe.data();
                                   
                                    var findEquipe = null;
                                    if (findEquipe == null) {
                                        for (var key in equipeData) {
                                            if (key == "contre" || key=="joueurs") {
                                                for (var joueur in equipeData[key]) {
                                                    if (equipeData[key][joueur] != null) {
                                                        if (equipeData[key][joueur].numero == this.numeroJoueur) {
                                                            findEquipe = docEquipe.ref;
                                                            this.myKey = key;
                                                             if (typeof(equipeData.pool)!="undefined")
                                                                this.numPoule = equipeData.pool;
                                                            this.$bind("equipe", findEquipe);
                                                            
                                                        }
                                                            
                                                    }
                                                }
                                            }
                                        }
                                    }
                                })
                            })
                }
            
            }
        },
        selectJoueur() {

        },
        
    },
    mounted() {
        this.initEquipe();
    }

}
</script>